import { FC } from 'react';

import {
  LayoutWithNavigationBreadcrumbs,
  NavigationBreadcrumbsTitles,
} from 'components';
import { FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  OperationFormContent,
  OperationFormContentProps,
} from 'modules/operation/common/components';

import {
  Form,
  getSchema,
  OperationFormType,
} from '../../common/forms/operationForm';
import { OperationFormFooter, OperationFormHeader } from '../components';
import { useOperationContext } from '../providers/OperationProvider';

export interface OperationViewProps
  extends Omit<OperationFormContentProps, 'mode'> {
  initialValues?: Partial<OperationFormType>;
  title: string;
  breadcrumbsTitles?: NavigationBreadcrumbsTitles;
  submitLoading?: boolean;
  brokerTimezoneOffset: number;
  onSubmit: FormSubmit<OperationFormType>;
}

export const OperationView: FC<OperationViewProps> = ({
  initialValues,
  title,
  breadcrumbsTitles,
  submitLoading,
  brokerTimezoneOffset,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const validationSchema = getSchema(t);

  const { operation } = useOperationContext();

  return (
    <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
      <Form
        hidePlaceholderIfReadonly
        initialReadOnly
        initialShowCopyButton
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <Stack spacing={24}>
          <OperationFormHeader title={title} />
          <OperationFormContent
            brokerTimezoneOffset={brokerTimezoneOffset}
            createdAt={operation.createdAt}
            mode="view"
            operationId={operation.id}
          />
          <OperationFormFooter submitLoading={submitLoading} />
        </Stack>
      </Form>
    </LayoutWithNavigationBreadcrumbs>
  );
};
